// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { ConversationStatus, IConversation } from '@/models/conversation.model';
import { IPagination } from '@/models/pagination.model';

// Components
import { Pagination, Table, TSelectOptions } from '@/ui';

// Helpers
import { getConversationColumns, TConversationFilters } from '../../helpers';

type TConversationsTableProps = {
  data: IConversation[] | null;
  isLoading?: boolean;
  pagination?: IPagination | null;
  onPageChange: (page: number) => void;
  filters?: TConversationFilters;
  onFilterChange: <K extends keyof TConversationFilters>(field: K, value: TConversationFilters[K]) => void;
  statusOptions?: TSelectOptions<ConversationStatus>;
};

const ConversationsTable: FC<TConversationsTableProps> = ({
  data,
  isLoading,
  pagination,
  onPageChange,
  filters,
  onFilterChange,
  statusOptions,
}) => {
  const { t } = useTranslation();

  const columns = getConversationColumns({
    t,
    filters,
    onFilterChange,
    statusOptions,
  });

  return (
    <>
      <Table
        loading={isLoading}
        columns={columns}
        rowKey="conversationId"
        dataSource={data ?? []}
        pagination={false}
        scroll={{ x: 'max-content' }}
        size="small"
      />
      <Pagination
        hideOnSinglePage
        total={pagination?.total}
        current={pagination?.page}
        pageSize={pagination?.pageSize}
        align="center"
        onChange={onPageChange}
      />
    </>
  );
};

export default ConversationsTable;
